"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitPointTaskRequest = void 0;
var SubmitPointTaskRequest = /** @class */ (function () {
    function SubmitPointTaskRequest() {
    }
    return SubmitPointTaskRequest;
}());
exports.SubmitPointTaskRequest = SubmitPointTaskRequest;
;
//# sourceMappingURL=submitPointTask.request.js.map